// ３点リーダー

export default function resizeClamp(timer) {
  // タイマーによって、リサイズ単位毎に関数が実行され、重くなるのを防ぐ
  if (timer !== false) {
    clearTimeout(timer);
  }
  timer = setTimeout(function () {
    $('.js-clamp').each(function () {

      var $target = $(this);
      var rest;
      if ($target.next().hasClass("js-ttl-rest")) {
        rest = $target.next().html();
        if (rest != "") {
          $target.html($target.html().slice(0, -3)); 
        }
        $target.next().remove();
      } else {
        rest = "";
      }

      var html = $target.html() + rest;
      var $clone = $target.clone();
      $clone.html(html);
      $clone
        .css({
          display: 'none',
        })
        .width($target.width())
        .height('auto');

      $clone.addClass("js-ttl-rest");
      $target.after($clone);

      rest = "";
      while ((html.length > 0) && ($clone.height() > $target.height())) {
        rest = html.substr(html.length - 1, 1) + rest;
        html = html.substr(0, html.length - 1);
        $clone.html(html + "..."); // 高さ更新
      }

      if (rest == "") {
        $target.html(html);
      } else {
        $target.html(html + '...');
      }
      $clone.html(rest);
    });
  }, 200);
}


// WEBPACK FOOTER //
// ./js/module/resizeClamp.js